module.exports = __webpack_public_path__ + "static/media/kite_surfing_768.07a202b8.webp";